<template>
	<button
		type="button"
		class="quiz-card"
		:class="{ 'quiz-card--wide': props.item.wide, 'quiz-card--selected': props.selected }"
		@click="emit('toggle')"
	>
		<div v-if="props.item.image" class="quiz-card__image">
			<img :src="props.item.image" :alt="props.item.name" />
		</div>
		<div class="quiz-card__text-block">
			<div v-if="props.item.title" class="quiz-card__title">{{ props.item.title }}</div>
			<div class="quiz-card__name">{{ props.item.name }}</div>
		</div>
		<span class="quiz-card__indicator"></span>
	</button>
</template>

<script setup lang="ts">
interface Props {
	item: QuizItem;
	selected: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits<{ toggle: [] }>();
</script>